import React from 'react'
import './tableOneEditModal.css'
import { useState, useRef } from 'react'

const TableOneEditModal = (props) => {

    const [tableOneRowDataTriger, setTableOneRowDataTriger] = useState(true);
    const [uploadProgress1, setUploadProgress1] = useState(0);
    const [uploadProgress2, setUploadProgress2] = useState(0);
    const [uploadProgress3, setUploadProgress3] = useState(0);
    const [uploadProgress4, setUploadProgress4] = useState(0);
    const [uploadProgress5, setUploadProgress5] = useState(0);
    const [uploadProgress6, setUploadProgress6] = useState(0);
    const [uploadProgress7, setUploadProgress7] = useState(0);
    const [copyTextColor, setCopyTextColor] = useState('blue');

    // const [uploadFileName1, setUploadFileName1] = useState();
    // const [uploadFileName2, setUploadFileName2] = useState();
    // const [uploadFileName3, setUploadFileName3] = useState();


    //Updated State.

    const [formData, setFormData] = useState({
        businessName: "KalaCoat", companyName: "", cusName: "", cusPhone: "", cusAdd: "", orderDate: "", orderNo: "",custOrderNo: "", stampVal: "", stampQty: "",
        inCusNameBtn: "", inCusName: "", inCusAddress: "", notary: "", bd: "", scan: "", ship: "", copies: "", state: "", vendor: "",
        shipLable: "", tracking: "", vendorNote: "", stampNo: "", stampBuyCost: "", scanDoc: "", scanQty: "", printQty: "", paidAmount:"",
        documents:"",fileName1: "", fileName2: "", fileName3: "", fileName7: "", status: "",certificate: "", shipName: "", shipAdd: "", shipPhone: "", quickrapid: "", orderNote: ""
    });

    const [formError, setFormError] = useState({});

    const orderDetails = useRef(null);
    const formRef = useRef(null);

    //console.log(props.tableOneEvent)
    //console.log(formData)
    
    // Update State Wtih TableOne Tr Data
    if(tableOneRowDataTriger){
        
        setTableOneRowDataTriger(false);
        const e = props.tableOneEvent;
            if(Object.keys(e).length!==0){
                //console.log(e)
                setFormData(() => ({
                    ...formData,
                    businessName: e.business_name, companyName: e.company_name, cusName: e.customer_name, cusPhone: e.customer_phone, cusAdd: e.customer_address, orderDate: e.date, orderNo: e.order_no,custOrderNo: e.cust_order_no, stampVal: e.stamp_value, stampQty: e.stamp_qty,
                    inCusNameBtn: e.in_cus_name?true:false, inCusName: e.in_cus_name, inCusAddress: e.in_cus_add, notary: e.notary===0?'':true, bd: e.bdated, scan: e.scan===0?'':true, ship: e.ship, copies: e.copies===0?'':e.copies, state: e.state, vendor: e.vendor,
                    shipLable: e.shiplabel, tracking: e.tracking_id, vendorNote: e.vendor_note, stampNo: e.stamp_no, stampBuyCost: e.stmp_buy_cost, scanDoc: e.scan_doc, scanQty: e.scan_qty, printQty: e.print_qty, paidAmount: e.paid_amount,
                    documents: e.documents, fileName1: e.documents.split("/")[0], fileName2: e.documents.split("/")[1], fileName3: e.documents.split("/")[2], status: e.status, certificate: e.certificate, shipName: e.ship_name, shipAdd: e.ship_address, shipPhone: e.ship_phone, quickrapid: e.quick_rapid, orderNote: e.order_note
                }));
            }
            
    }
    
    //console.log(formData)

    const changeCopyTextColor = () => {
        setCopyTextColor('lightblue');
        setTimeout(() => {
            setCopyTextColor('blue');
        }, 400);
    }

    const onChangeHandler = (event) => {
        //console.log(event.target.name, event.target.checked)
        // groups: ["Admin", "SupportAdmin", "SupportUser", "Packer", "Shipper"],
        // controls: ["Read", "Write", "None"],
        // feilds: ["companyName", "cusName", "cusPhone", "cusAdd", "orderDate", "custOrderNo", " stampVal", "stampQty", "inCusNameBtn", "quickrapid", "notary", "bd", "certificate", " scan", "copies", "stampNo", "scanQty", "printQty", "tracking", "ship", "shipName", " shipPhone", "shipAdd", "state", "vendor", "status", "orderNote", "vendorNote", "vendorNote"],
        
        
        
        
        if(parseJwt().result.active && parseJwt().result.role==="Shipper"){
            if(event.target.name!=="status"){
                return alert('You Dont Have Access To Modify This Item.')
            }
        }    

        if (event.target.value == 'on') {
            //console.log(event.target.checked)
            setFormData(() => ({
                ...formData,
                [event.target.name]: event.target.checked
            }))
        } else {
            if(event.target.name==="custOrderNo"){
                //console.log(event.target.value.replace(/\s+/g, ''))
                setFormData(() => ({
                    ...formData,
                    [event.target.name]: event.target.value.replace(/\s+/g, '')
                }))
                
            }else{
                    setFormData(() => ({
                        ...formData,
                        [event.target.name]: event.target.value
                    }))
                }
            event.target.style.border = '0'
        }
        
    }

    const formValidation = () => {
        const err = {}

        if (formData.companyName === '') { err.companyName = 'Company Name Required' } else { delete err.companyName }
        if (formData.cusName === '') { err.cusName = 'Customer Name Required' } else { delete err.cusName }
        // if (formData.cusPhone === '') { err.cusPhone = 'Company Name Required' } else { delete err.cusPhone }

        if (formData.cusAdd === '') { err.cusAdd = 'Company Name Required' } else { delete err.cusAdd }
        if (formData.orderDate === '') { err.orderDate = 'Company Name Required' } else { delete err.orderDate }
        if (formData.stampVal === '') { err.stampVal = 'Company Name Required' } else { delete err.stampVal }
        if (formData.stampQty === '') { err.stampQty = 'Company Name Required' } else { delete err.stampQty }

        if (formData.inCusNameBtn) {
            if (formData.inCusName === '') { err.inCusName = 'Company Name Required' } else { delete err.inCusName }
            if (formData.inCusAddress === '') { err.inCusAddress = 'Company Name Required' } else { delete err.inCusAddress }
        }

        if (formData.ship) {
            if (formData.shipName === '') { err.shipName = 'Company Name Required' } else { delete err.shipName }
            if (formData.shipPhone === '') { err.shipPhone = 'Company Name Required' } else { delete err.shipPhone }
            if (formData.shipAdd === '') { err.shipAdd = 'Company Name Required' } else { delete err.shipAdd }
        }

        if (formData.status == '') { err.status = 'Status Name Required' } else { delete err.status }

        
        setFormError({ ...err })
        
        return Object.keys(err).length < 1;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const isValid = formValidation()
        
        if(uploadProgress1>0 && uploadProgress1<1){ return alert('File Upload Under Progress...')}
        if(uploadProgress2>0 && uploadProgress2<1){ return alert('File Upload Under Progress...')}
        if(uploadProgress3>0 && uploadProgress3<1){ return alert('File Upload Under Progress...')}
        if(uploadProgress4>0 && uploadProgress4<1){ return alert('File Upload Under Progress...')}
        if(uploadProgress7>0 && uploadProgress7<1){ return alert('File Upload Under Progress...')}
        
        if (isValid) {
            //console.log('form submited')
            props.spinner(true);
            const createOrders = async () => {
                
                try {
                    await fetch(process.env.REACT_APP_BASE_URL+'/api/support/orders', {
                        method: Object.keys(props.tableOneEvent).length!==0?"PATCH":"POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": localStorage.getItem("loginToken")
                        },
                        redirect: "manual",
                        body: JSON.stringify({
                            "id":Object.keys(props.tableOneEvent).length!==0?props.tableOneEvent.id:"",
                            "date": formatDate(formData.orderDate, "y/m/d"),
                            "business_name": formData.businessName,
                            "company_name": formData.companyName,
                            "customer_name": formData.cusName,
                            "customer_phone": formData.cusPhone,
                            "customer_address": formData.cusAdd,
                            "stamp_value": formData.stampVal,
                            "stamp_qty": formData.stampQty,
                            "notary": formData.notary,
                            "in_cus_name": formData.inCusName,
                            "in_cus_add": formData.inCusAddress,
                            "bdated": formData.bd!==""?formatDate(formData.bd, "y/m/d"):'0000-00-00',
                            "certificate": formData.certificate,
                            "scan": formData.scan,
                            "copies": formData.copies,
                            "ship": formData.ship,
                            "ship_name": formData.shipName,
                            "ship_phone": formData.shipPhone,
                            "ship_address": formData.shipAdd,
                            "documents": formData.fileName1+'/'+formData.fileName2+'/'+formData.fileName3,
                            "state": formData.state,
                            "vendor": formData.vendor,
                            "vendor_note": formData.vendorNote,
                            "status": formData.status,
                            "order_note": formData.orderNote,
                            "quick_rapid": formData.quickrapid,
                            "cust_order_no": formData.custOrderNo,
                            "scan_doc": formData.scanDoc,
                            "stamp_no": formData.stampNo,
                            "stmp_buy_cost": formData.stampBuyCost,
                            "print_qty": formData.printQty,
                            "scan_qty": formData.scanQty,
                            "tracking_id": formData.tracking,
                            "shiplabel": formData.shipLable,
                            "paid_amount": formData.paidAmount
                        }),
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            //result.success==1 ? <div className='center-popup'>Successfully Create Order!</div> : <div className='center-popup'>Failed to Create Order!</div>
                            props.showHideModal(false);
                            props.tableOneRefresh();
                            //console.log(result);
                        })
                }
                catch (error) {
                    console.log(error);
                }
            }

            createOrders();

        }
        //console.log(formData)


    }

    const handleInCusNameBtn = () => {

        setFormData(() => ({
            ...formData,
            inCusNameBtn: !formData.inCusNameBtn,
            inCusName: "", inCusAddress: ""
        }));
    }

    // const orderSummaryAction = (services) => {
    //     //setOrderSummary(services);
    // }

    //console.log(orderDetails.current?.innerText || "ref not set!")

    const FileUploadHandler = (event) => {
        
        const file = event.target.files[0];
        //console.log(file.type)
        //pdf - application/pdf
        //docx - application/vnd.openxmlformats-officedocument.wordprocessingml.document
        //xlsx - application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        //jpeg - image/jpeg
        //png - image/png
        if (file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/pdf') {
            alert('Please select a DOCX or PDF file only.');
            return;
        }

        if (file.size > 5120 * 5120) {
            alert('File size should not exceed 5MB.');
            return;
        }

        const divNumber = event.target.id.split("-")[2]

        divNumber == 1 && setFormData(() => ({ ...formData, ['fileName1']: file.name}))
        //divNumber == 1 && setUploadFileName1(file.name)
        divNumber == 2 && setFormData(() => ({ ...formData, ['fileName2']: file.name}))
        //divNumber == 2 && setUploadFileName2(file.name)
        divNumber == 3 && setFormData(() => ({ ...formData, ['fileName3']: file.name}))
        //divNumber == 3 && setUploadFileName3(file.name)
        divNumber == 4 && setFormData(() => ({ ...formData, ['scanDoc']: file.name}))
        divNumber == 7 && setFormData(() => ({ ...formData, ['shipLable']: file.name}))

        const fd = new FormData();
        fd.append('avtar', file);
        // setUploadProgress(0.4)

        /*
        fetch('http://arobaniworks.com/api/support/upload', {
            method: 'POST',
            body: fd,
            redirect: "follow",
            headers:{
                Authorization: localStorage.getItem("loginToken")
            }
        })
        .then((res) => res.text())
        .then((result) => { console.log(result); setUploadProgress(1) })
        .catch(err => {console.log(err); setUploadProgress(0) })
        */

        async function main(inputNo) {
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState == XMLHttpRequest.DONE) {
                    var jsonResponse = JSON.parse(xhr.responseText);
                    divNumber == 1 && setFormData(() => ({ ...formData, ['fileName1']: jsonResponse.file.filename}));
                    divNumber == 2 && setFormData(() => ({ ...formData, ['fileName2']: jsonResponse.file.filename}));
                    divNumber == 3 && setFormData(() => ({ ...formData, ['fileName3']: jsonResponse.file.filename}));
                    divNumber == 4 && setFormData(() => ({ ...formData, ['scanDoc']: jsonResponse.file.filename}));
                    divNumber == 7 && setFormData(() => ({ ...formData, ['shipLable']: jsonResponse.file.filename}));
                    
                }
            }
            const success = await new Promise((resolve) => {
                xhr.upload.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        //console.log("upload progress:", event.loaded / event.total);
                        // uploadProgress.value = event.loaded / event.total;
                        inputNo == 1 && setUploadProgress1(event.loaded / event.total)
                        inputNo == 2 && setUploadProgress2(event.loaded / event.total)
                        inputNo == 3 && setUploadProgress3(event.loaded / event.total)
                        inputNo == 4 && setUploadProgress4(event.loaded / event.total)
                        inputNo == 7 && setUploadProgress7(event.loaded / event.total)
                    }
                });
                xhr.open("POST", process.env.REACT_APP_BASE_URL+"/api/support/upload", true);
                // xhr.setRequestHeader("Content-Type", "application/octet-stream");
                xhr.setRequestHeader("Authorization", localStorage.getItem("loginToken"));
                xhr.send(fd);
            })
            console.log("SuccessIs:", success);
        }

        main(event.target.id.split("-")[2]).catch(console.error);
        
        //console.log('ID is - '+ event.target.id.split("-")[2] )
        //console.log(event.target.files[0].name)


    }

    // const statusHandler = () => {
    //     const statusOptions = ['New', 'Created', 'Vendor', 'Completed', 'Closed', 'On Hold'];
    //     if (formData.vendor=="") {
    //         return statusOptions[2];
    //     }
    //     if (!formData.vendor!="") {
    //         return statusOptions[1];
    //     }
    //     return statusOptions[0];
    // }

    // const disableEdit = () => {
    //     let disabledStatus = ['Closed', 'Completed', 'Transit']
    //     for(let i=0;i<disabledStatus.length;i++){
    //         if(disabledStatus[i]===props.tableOneEvent.status){
    //             return true
    //         }
    //     }
    //     return false
    // }
    
    const formatDate = (date, format='y/m/d') => {
        //2024-12-31
        const formatarr = format.split("");
        const y = new Date(date).toLocaleString('default', { year: 'numeric' }) ;
        const m = new Date(date).toLocaleString('default', { month: '2-digit' }) ;
        const d = new Date(date).toLocaleString('default', { day: '2-digit' })
        const finalvalue = 
        (formatarr[0]=='d' && d || formatarr[0]=='m' && m || formatarr[0]=='y' && y) + 
        formatarr[1] + 
        (formatarr[2]=='d' && d || formatarr[2]=='m' && m || formatarr[2]=='y' && y) + 
        formatarr[3] + 
        (formatarr[4]=='d' && d || formatarr[4]=='m' && m || formatarr[4]=='y' && y)
        return finalvalue
    }
    
    // const addNewChildTab = () => {
    //     <button className='table-one-tab'>Child <span className='table-one-tab-close'>+</span></button>
    // }

    const fileTypeColor = (fileName) => {
        var extn = fileName.split(".").pop();
        if(extn==="pdf"){
            return "red"
        }
        if(extn==="docx" || extn==="doc"){
            return "blue"
        }
    }

    // const userAccess = () => {
    //     if(user==="Admin"){

    //     }
    //     if(user==="supportAdmin"){
            
    //     }
    //     if(user==="supportUser"){
            
    //     }
    //     if(user==="packing"){
            
    //     }
    //     if(user==="shipping"){
            
    //     }
    // }
    

    function parseJwt (token = localStorage.getItem("loginToken") ) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }
    
    //console.log( parseJwt().result.role , parseJwt().result.active);


        const access = {
            // groups: ["admin", "supportAdmin", "supportUser", "packer", "shipper"],
            // controls: ["Read", "Write", "None"],
            // feilds: ["companyName", "cusName", "cusPhone", "cusAdd", "orderDate", "custOrderNo", " stampVal", "stampQty", "inCusNameBtn", "quickrapid", "notary", "bd", "certificate", " scan", "copies", "stampNo", "scanQty", "printQty", "tracking", "ship", "shipName", " shipPhone", "shipAdd", "state", "vendor", "status", "orderNote", "vendorNote", "vendorNote"],

            supportAdmin: {
                companyName: "Write", cusName: "Write", cusPhone: "Write", cusAdd: "Write", orderDate: "Write", custOrderNo: "Write",
                stampVal: "Write", stampQty: "Write", inCusNameBtn: "Write", quickrapid: "Write", notary: "Write", bd: "Write", certificate: "Write",
                scan: "Write", copies: "Write", stampNo: "Write", scanQty: "Write", printQty: "Write", tracking: "Write", ship: "Write", shipName: "Write",
                shipPhone: "Write", shipAdd: "Write", state: "Write", vendor: "Write", status: "Write", orderNote: "Write", vendorNote: "Write"
            },
            supportUser: {
                companyName: "Write", cusName: "Write", cusPhone: "Write", cusAdd: "Write", orderDate: "Write", custOrderNo: "Write",
                stampVal: "Write", stampQty: "Write", inCusNameBtn: "Write", quickrapid: "Write", notary: "Write", bd: "Write", certificate: "Write",
                scan: "Write", copies: "Write", stampNo: "Write", scanQty: "Write", printQty: "Write", tracking: "Write", ship: "Write", shipName: "Write",
                shipPhone: "Write", shipAdd: "Write", state: "Write", vendor: "Write", status: "Write", orderNote: "Write", vendorNote: "Write"
            },
            packer: {
                companyName: "Write", cusName: "Write", cusPhone: "Write", cusAdd: "Write", orderDate: "Write", custOrderNo: "Write",
                stampVal: "Write", stampQty: "Write", inCusNameBtn: "Write", quickrapid: "Write", notary: "Write", bd: "Write", certificate: "Write",
                scan: "Write", copies: "Write", stampNo: "Write", scanQty: "Write", printQty: "Write", tracking: "Write", ship: "Write", shipName: "Write",
                shipPhone: "Write", shipAdd: "Write", state: "Write", vendor: "Write", status: "Write", orderNote: "Write", vendorNote: "Write"
            },
            shipper: {
                companyName: "Write", cusName: "Write", cusPhone: "Write", cusAdd: "Write", orderDate: "Write", custOrderNo: "Write",
                stampVal: "Write", stampQty: "Write", inCusNameBtn: "Write", quickrapid: "Write", notary: "Write", bd: "Write", certificate: "Write",
                scan: "Write", copies: "Write", stampNo: "Write", scanQty: "Write", printQty: "Write", tracking: "Write", ship: "Write", shipName: "Write",
                shipPhone: "Write", shipAdd: "Write", state: "Write", vendor: "Write", status: "Write", orderNote: "Write", vendorNote: "Write"
            },
            get(feild) {
                var currentUser = ""
                return this.currentUser.feild
            }

        }
        
        const permissions = {
            // groups: ["admin", "supportAdmin", "supportUser", "packer", "shipper"],
            // controls: ["Read", "Write", "None"],
            // feilds: ["companyName", "cusName", "cusPhone", "cusAdd", "orderDate", "custOrderNo", " stampVal", "stampQty", "inCusNameBtn", "quickrapid", "notary", "bd", "certificate", " scan", "copies", "stampNo", "scanQty", "printQty", "tracking", "ship", "shipName", " shipPhone", "shipAdd", "state", "vendor", "status", "orderNote", "vendorNote", "vendorNote"],
            companyName:{Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            cusName:    {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            cusPhone:   {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"H"},
            cusAdd:     {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            paidAmount: {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            orderDate:  {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            custOrderNo:{Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            stampVal:   {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            stampQty:   {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            inCusNameBtn:{Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            inCusName:  {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            inCusAddress:{Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            quickrapid: {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            notary:     {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            bd:         {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            certificate:{Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            scan:       {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            copies:     {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            custFiles:  {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            vendorFiles:{Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            stampNo:    {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            scanQty:    {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            printQty:   {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            shipLabel:  {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            tracking:   {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            ship:       {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            shipName:   {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            shipPhone:  {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            shipAdd:    {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            state:      {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            vendor:     {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            status:     {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"W"},
            orderSummary:{Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            orderNote:  {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            vendorNote: {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"R"},
            submit:     {Admin:"W",SupportAdmin:"W",SupportUser:"R",Packer:"R", Shipper:"W"},
            reOpenBtn:  {Admin:"W",SupportAdmin:"W",SupportUser:"H",Packer:"H", Shipper:"H"},
            
            parseJwt(token = localStorage.getItem("loginToken")){
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
                return JSON.parse(jsonPayload);
            },
            get(feildName){
                var access = this.parseJwt().result.role ;
                if(feildName==="custFiles" || feildName==="vendorFiles" || feildName==="shipLabel" || feildName==="orderSummary"){
                    if(this[feildName][access]==="W"){ return {}}
                    if(this[feildName][access]==="R"){ return {pointerEvents: 'none'}}
                    if(this[feildName][access]==="H"){ return {display: 'none'}}
                }

                if(feildName==="submit"){
                    let orderstatus = props.tableOneEvent.status ;
                    if(orderstatus==='Closed'||orderstatus==='Completed'||orderstatus==='Transit'){return {display: 'none'}}
                    else{
                        if(this[feildName][access]==="W"){ return {}}
                        if(this[feildName][access]==="R"){ return {pointerEvents: 'none'}}
                        if(this[feildName][access]==="H"){ return {display: 'none'}}
                        return {display: 'block'}
                    }
                }

                if(feildName==="reOpenBtn"){
                    let status = props.tableOneEvent.status ;
                    if(status==='Closed'||status==='Completed'||status==='Transit'){
                        if(this[feildName][access]==="W"){ return {display:'block'}}
                        if(this[feildName][access]==="R"){ return {display:'block', pointerEvents: 'none'}}
                        if(this[feildName][access]==="H"){ return {display:'none'}}
                    }
                }
                
                if(this[feildName][access]==="W"){ return {disabled: false}}
                if(this[feildName][access]==="R"){ return {disabled: true}}
                if(this[feildName][access]==="H"){ return {hidden: true}}
                return {disabled: true}
            },
            async reOpenCase(){
                const status = props.tableOneEvent.status ;
                try {
                    await fetch(process.env.REACT_APP_BASE_URL+'/api/support/orders', {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": localStorage.getItem("loginToken")
                        },
                        redirect: "manual",
                        body: JSON.stringify({
                            "id":props.tableOneEvent.id,
                            "status": "Office",
                        }),
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            props.showHideModal(false);
                            props.tableOneRefresh();
                        })
                }
                catch (error) {
                    console.log(error);
                }
            }
            


        }
        
        

    return (
        <div className='tableOnceEditModal-container'>
        
        {/* <div className='center-popup'>Successfully Create Order!</div> */}

            <div id="tableOnceEditModal-box" className='tableOnceEditModal-box'>
                {/* <div className='table-one-tabs'>
                    <button className='table-one-tab'>Order <span className='table-one-tab-close'>+</span></button>
                    <button className='table-one-tab'>Child <span className='table-one-tab-close'>+</span></button>
                    <button onClick={() => addNewChildTab} className='table-one-add-tab-btn' title='New Tab'><span class="material-symbols-outlined">add</span></button>
                </div> */}
                <form ref={formRef} className="editTable-form" onSubmit={handleSubmit}>
                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 5px', fontWeight: '200' }}><span style={{ width: '100%', textAlign: 'center' }}><b>Customer Details</b></span> <span style={{ color: 'blue' }}>{formData.orderNo}</span></div> */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 5px', fontWeight: '800' }}>
                        <span style={{ width: '100%', textAlign: 'center',color:'blue' }}><b>{formData.custOrderNo}</b></span>
                        {/* <span style={{ width: '100%', textAlign: 'center',color:'blue' }}><b>{formData.orderNo}</b></span> */}
                    </div>
                    <div style={{border:'1px grey solid'}}>
                        <div className='separater-line'>Customer Details</div>
                        
                        <div className='formRow'>
                            {/* <input type="text" placeholder="Business Name" value={formData.business_name} onChange={({ target }) => setFormData({business_name:target.value})} /> */}
                            {/* <input type="text" placeholder="Company Name" value={formData.company_name} onChange={({ target }) => setFormData({company_name:target.value})} /> */}
                            
                            <select {...permissions.get('companyName')} value={formData.companyName} style={formError.companyName ? { border: '1px solid red' } : { border: '0' }} name='companyName' className='formCol' onChange={onChangeHandler} >
                                <option value="">Company Name</option>
                                <option value="Aspera">Aspera</option>
                                <option value="KalaCoat">KalaCoat</option>
                                <option value="eDraft">eDraft</option>
                            </select>
                            <input {...permissions.get('cusName')} style={formError.cusName ? { border: '1px solid red' } : { border: '0' }} name='cusName' className='formCol' type="text" placeholder="Customer Name" value={formData.cusName} onChange={onChangeHandler} />
                            <input {...permissions.get('cusPhone')} name='cusPhone' className='formCol' type="text" placeholder="Customer Phone" value={formData.cusPhone} onChange={onChangeHandler} />
                        </div>
                        {/* Added From Here. */}
                        <div>
                            <div className='formRow'>
                                <input {...permissions.get('cusAdd')} style={formError.cusAdd ? { border: '1px solid red', width: '97.5%' } : { border: '0', width: '97.5%' }} name='cusAdd' className='formCol' type="text" placeholder="Customer Address" value={formData.cusAdd} onChange={onChangeHandler} />
                                {formData.companyName==="KalaCoat" && <input {...permissions.get('paidAmount')} style={{width:'20%'}}  name='paidAmount' className='formCol' type="text" placeholder="Paid Amount" value={formData.paidAmount} onChange={onChangeHandler} />}
                            </div>
                            {/* <div className='tooltip'>
                                <input style={formError.orderDate ? { border: '1px solid red' } : { border: '0' }} name='orderDate' type="date" placeholder="Order Date" value={formatDate(formData.orderDate, "y-m-d")} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Order Date</div>
                            </div>
                            <div className='tooltip'>
                                <input name='custOrderNo' style={{ width: '120px' }} type="text" placeholder="Customer Order #" value={formData.custOrderNo} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Customer Order#</div>
                            </div> */}
                        
                        </div>
                        <div>
                            <div className='formRow'>
                                <input {...permissions.get('paidAmount')} style={{width:'50%'}}  name='paidAmount' className='formCol' type="text" placeholder="Email ID" value={formData.paidAmount} onChange={onChangeHandler} />
                            </div> 
                        </div>       

                    </div>
                    <div style={{border:'1px grey solid'}}>
                        <div className='separater-line'>Order Details</div>
                        
                        {/* <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 5px', fontWeight: '200' }}><span style={{ width: '100%', textAlign: 'center' }}><b>Order Details</b></span> <span style={{ color: 'white' }}>{formData.orderNo}</span></div> */}
                        <div style={{display:'flex',width:'100%',justifyContent:'space-evenly',flexWrap:'wrap'}}>
                            <div className='tooltip'>
                                <input {...permissions.get('orderDate')} style={formError.orderDate ? { border: '1px solid red' } : { border: '0' }} name='orderDate' type="date" placeholder="Order Date" value={formatDate(formData.orderDate, "y-m-d")} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Order Date</div>
                            </div>
                            <div className='tooltip'>
                                <input {...permissions.get('custOrderNo')} name='custOrderNo' style={{ width: '120px' }} type="text" placeholder="Customer Order #" value={formData.custOrderNo} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Customer Order#</div>
                            </div>
                            {/* <input type="text" placeholder="Stamp Value" value={formData.stamp_value} onChange={({ target }) => setFormData({stamp_value:target.value})} /> */}
                            
                            <div className='tooltip'>
                                <select {...permissions.get('stampVal')} value={formData.stampVal} style={formError.stampVal ? { border: '1px solid red', width: '70px' } : { border: '0', width: '60px' }} name='stampVal' onChange={onChangeHandler} >
                                    <option value="">Value</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="500">500</option>
                                </select>
                                <div className='tooltiptext'>Stamp Value</div>
                            </div>
                            
                            <div className='tooltip'>
                                <input {...permissions.get('stampQty')} style={formError.stampQty ? { border: '1px solid red', width: '60px' } : { border: '0', width: '60px' }} name='stampQty' className="tooltip" type="number" placeholder="Qty" value={formData.stampQty} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Stamp&nbsp;Qty</div>
                            </div>
                            
                            <div className='tooltip'>
                                {/* <label style={{ paddingLeft: '8px' }} htmlFor="1">In Cus Name</label> */}
                                <input {...permissions.get('inCusNameBtn')} defaultChecked={formData.inCusName?true:false} name='inCusNameBtn' type="checkbox" onChange={handleInCusNameBtn} />
                                <div className='tooltiptext'>In&nbsp;Cust&nbsp;Name</div>
                            </div>
                            <div className='tooltip'>
                                <select {...permissions.get('quickrapid')} value={formData.quickrapid} style={formError.quickrapid ? { border: '1px solid red', width: '70px' } : { border: '0', width: '70px' }} name='quickrapid' onChange={onChangeHandler} >
                                    <option value=""></option>
                                    <option value="quick">Quick</option>
                                    <option value="rapid">Rapid</option>
                                </select>
                                <div className='tooltiptext'>Quick/Rapid</div>
                            </div>
                            

                        </div>

                        {formData.inCusNameBtn &&
                            <div className='formRow'>
                                <input {...permissions.get('inCusName')} style={formError.inCusName ? { border: '1px solid red', width: "30%" } : { border: '0', width: "30%" }} name='inCusName' className='formCol' type="text" placeholder="Stamp In Name" value={formData.inCusName} onChange={onChangeHandler} />
                                <input {...permissions.get('inCusAddress')} style={formError.inCusAddress ? { border: '1px solid red', width: "70%" } : { border: '0', width: "70%" }} name='inCusAddress' className='formCol' type="text" placeholder="Stamp In Address" value={formData.inCusAddress} onChange={onChangeHandler} />
                            </div>
                        }

                        {/* <div className='separater-line'></div>     */}

                        <div className='formRow' style={{ padding: '8px',borderRadius:'10px',justifyContent:'space-evenly'}}>
                            <div className='formCol' style={{ textAlign: 'center' }}>
                                <label style={{display:'block'}} htmlFor="2">Notary</label>
                                <input {...permissions.get('notary')} defaultChecked={formData.notary} name='notary' type="checkbox" id="2" placeholder="Notary" onChange={onChangeHandler} />
                            </div>
                            <div className='formCol' style={{ textAlign: 'center',width:'100%' }}>
                                {/* <label htmlFor="3">Back Dated</label>
                                <input defaultChecked={formData.bd} name='bd' type="checkbox" id="3" placeholder="Back Dated" onChange={onChangeHandler} /> */}
                                <label style={{display:'block'}} htmlFor="3">Back Dated</label>
                                <input {...permissions.get('bd')} title='Back Dated' name='bd' type="date" id="3" value={formatDate(formData.bd, 'y-m-d')} onChange={onChangeHandler} />
                            </div>
                            <div className='formCol' style={{ textAlign: 'center' }}>
                                <label style={{display:'block'}} htmlFor="12">Certificate</label>
                                <input {...permissions.get('certificate')} defaultChecked={formData.certificate} name='certificate' type="checkbox" id="12" placeholder="Certificate" onChange={onChangeHandler} />
                            </div>
                            <div className='formCol' style={{ textAlign: 'center' }}>
                                <label style={{display:'block'}} htmlFor="4">Scan</label>
                                <input {...permissions.get('scan')} defaultChecked={formData.scan} name='scan' type="checkbox" id="4" placeholder="Scan" onChange={onChangeHandler} />
                            </div>
                            {/* <div className='formCol' style={{ textAlign: 'center' }}>
                                <label style={{display:'block'}} htmlFor="5">Ship</label>
                                <input defaultChecked={formData.ship} name='ship' type="checkbox" id="5" placeholder="Ship" onChange={onChangeHandler} />
                            </div> */}
                            {/* <div className='formCol' style={{ textAlign: 'center' }}>
                                <label style={{display:'block'}} >Shipping</label>
                                <select value={formData.ship.toString()} style={formError.ship ? { border: '1px solid red', width: '85px' } : { border: '0', width: '85px' }} name='ship' onChange={onChangeHandler} >
                                    <option value=""></option>
                                    <option value="1">Normal</option>
                                    <option value="2">Express</option>
                                </select>
                            </div> */}
                            <div className='formCol' style={{ textAlign: 'center' }}>
                                <label style={{display:'block'}} htmlFor="6">Copies</label>
                                <input {...permissions.get('copies')} name='copies' style={{ width: '50px' }} type="number" id="6" value={formData.copies} onChange={onChangeHandler} />
                            </div>
                        </div>
                        
                        
                        

                        <div style={{ display: 'flex', ...permissions.get('custFiles') , position:'relative',width:'100%',height:'6rem', alignItems: 'end', justifyContent: 'flex-start', padding: '5px 8px' }}>
                            <div style={{width:'50%',position:'absolute', left:'0',top:'0',fontSize:'10px'}} className='separater-line'>Customer Files</div>
                            <div style={{ width:'50%',display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', padding: '0 8px' }}>
                                <div  className='file-upload-col'>
                                    {/* <label className='tooltip'>{formData.fileName1.length>5?"..."+formData.fileName1.slice(-20):formData.fileName1}<div className='tooltiptext'>{formData.fileName1}</div></label> */}
                                    {/* <label htmlFor="file-upload-1" className="custom-file-upload">Upload</label> */}
                                    {formData.fileName1?
                                        <div className='tooltip' style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px',color:fileTypeColor(formData.fileName1)}}>
                                            <span onClick={() => {setFormData(() => ({...formData, fileName1:""})); setUploadProgress1(0);}} style={{position:'absolute',right:'0',top:'0',fontSize:'18px',cursor:'pointer'}} className="material-symbols-outlined">close</span>
                                            <span style={{position:'absolute',left:'20%',top:'20%',fontSize:'34px'}} className="material-symbols-outlined">description</span>
                                            <div className='tooltiptext'>{formData.fileName1}</div>
                                        </div>
                                    :
                                        <div style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px'}}>
                                            <label style={{cursor:'pointer',position:'absolute',right:'25%',top:'20%',fontSize:'18px'}} htmlFor="file-upload-1"><span className="material-symbols-outlined">upload</span></label>
                                            <input id="file-upload-1" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} />
                                        </div>
                                    }
                                    {/* <span>Uploading...</span> */}
                                    <progress style={{width:'80%'}} value={uploadProgress1} />
                                </div>
                                <div className='file-upload-col'>
                                    {/* <label className='tooltip'>{formData.fileName2.length>5?"..."+formData.fileName2.slice(-20):formData.fileName2} <div className='tooltiptext'>{formData.fileName2}</div> </label>
                                    <label htmlFor="file-upload-2" className="custom-file-upload">Upload</label>
                                    <input id="file-upload-2" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} /> */}
                                    {formData.fileName2?
                                        <div className='tooltip' style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px',color:fileTypeColor(formData.fileName2)}}>
                                            <span onClick={() => {setFormData(() => ({...formData, fileName2:""})); setUploadProgress2(0);}} style={{position:'absolute',right:'0',top:'0',fontSize:'18px',cursor:'pointer'}} className="material-symbols-outlined">close</span>
                                            <span style={{position:'absolute',left:'20%',top:'20%',fontSize:'34px'}} className="material-symbols-outlined">description</span>
                                            <div className='tooltiptext'>{formData.fileName2.split("_")[1]}</div>
                                        </div>
                                    :
                                        <div style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px'}}>
                                            <label style={{cursor:'pointer',position:'absolute',right:'25%',top:'20%',fontSize:'18px'}} htmlFor="file-upload-2"><span className="material-symbols-outlined">upload</span></label>
                                            <input disabled={!formData.fileName1} id="file-upload-2" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} />
                                        </div>
                                    }
                                    {/* <span>Uploading...</span> */}
                                    <progress style={{width:'80%'}} value={uploadProgress2} />
                                </div>
                                <div className='file-upload-col'>
                                    {/* <label className='tooltip'>{formData.fileName3.length>5?"..."+formData.fileName3.slice(-20):formData.fileName3}<div className='tooltiptext'>{formData.fileName3}</div></label>
                                    <label htmlFor="file-upload-3" className="custom-file-upload">Upload</label>
                                    <input id="file-upload-3" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} /> */}
                                    {formData.fileName3?
                                        <div className='tooltip' style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px',color:fileTypeColor(formData.fileName3)}}>
                                            <span onClick={() => {setFormData(() => ({...formData, fileName3:""})); setUploadProgress3(0);}} style={{position:'absolute',right:'0',top:'0',fontSize:'18px',cursor:'pointer'}} className="material-symbols-outlined">close</span>
                                            <span style={{position:'absolute',left:'20%',top:'20%',fontSize:'34px'}} className="material-symbols-outlined">description</span>
                                            <div className='tooltiptext'>{formData.fileName3.split("_")[1]}</div>
                                        </div>
                                    :
                                        <div style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px'}}>
                                            <label style={{cursor:'pointer',position:'absolute',right:'25%',top:'20%',fontSize:'18px'}} htmlFor="file-upload-3"><span className="material-symbols-outlined">upload</span></label>
                                            <input disabled={!formData.fileName2} id="file-upload-3" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} />
                                        </div>
                                    }
                                    {/* <span>Uploading...</span> */}
                                    <progress style={{width:'80%'}} value={uploadProgress3} />
                                </div>
                            </div>

                            <div style={{width:'50%',position:'absolute', right:'0',top:'0',fontSize:'10px'}} className='separater-line'>Vendor Files</div>
                            <div style={{ width:'50%',display: 'flex', ...permissions.get('vendorFiles'), alignItems: 'center', justifyContent: 'space-evenly', padding: '0 8px' }}>
                                <div  className='file-upload-col'>
                                    {/* <label className='tooltip'>{formData.fileName1.length>5?"..."+formData.fileName1.slice(-20):formData.fileName1}<div className='tooltiptext'>{formData.fileName1}</div></label> */}
                                    {/* <label htmlFor="file-upload-1" className="custom-file-upload">Upload</label> */}
                                    {formData.scanDoc?
                                        <div className='tooltip' style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px',color: fileTypeColor(formData.scanDoc)}}>
                                            <span onClick={() => {setFormData(() => ({...formData, scanDoc:""})); setUploadProgress4(0);}} style={{position:'absolute',right:'0',top:'0',fontSize:'18px',cursor:'pointer'}} className="material-symbols-outlined">close</span>
                                            <span style={{position:'absolute',left:'20%',top:'20%',fontSize:'34px'}} className="material-symbols-outlined">description</span>
                                            <div className='tooltiptext'>{formData.scanDoc.split("_")[1]}</div>
                                        </div>
                                    :
                                        <div style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px'}}>
                                            <label style={{cursor:'pointer',position:'absolute',right:'25%',top:'20%',fontSize:'18px'}} htmlFor="file-upload-4"><span className="material-symbols-outlined">upload</span></label>
                                            <input id="file-upload-4" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} />
                                        </div>
                                    }
                                    {/* <span>Uploading...</span> */}
                                    <progress style={{width:'80%'}} value={uploadProgress4} />
                                </div>
                                <div className='file-upload-col'>
                                    {/* <label className='tooltip'>{formData.fileName2.length>5?"..."+formData.fileName2.slice(-20):formData.fileName2} <div className='tooltiptext'>{formData.fileName2}</div> </label>
                                    <label htmlFor="file-upload-2" className="custom-file-upload">Upload</label>
                                    <input id="file-upload-2" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} /> */}
                                    {false?
                                        <div className='tooltip' style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px',color:fileTypeColor(formData.scanDoc)}}>
                                            <span style={{position:'absolute',right:'0',top:'0',fontSize:'18px',cursor:'pointer'}} className="material-symbols-outlined">close</span>
                                            <span style={{position:'absolute',left:'20%',top:'20%',fontSize:'34px'}} className="material-symbols-outlined">description</span>
                                            <div className='tooltiptext'>{formData.fileName2.split("_")[1]}</div>
                                        </div>
                                    :
                                        <div style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px'}}>
                                            <label style={{cursor:'pointer',position:'absolute',right:'25%',top:'20%',fontSize:'18px'}} htmlFor="file-upload-5"><span className="material-symbols-outlined">upload</span></label>
                                            <input disabled id="file-upload-5" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} />
                                        </div>
                                    }
                                    {/* <span>Uploading...</span> */}
                                    <progress style={{width:'80%'}} value={uploadProgress5} />
                                </div>
                                <div className='file-upload-col'>
                                    {/* <label className='tooltip'>{formData.fileName3.length>5?"..."+formData.fileName3.slice(-20):formData.fileName3}<div className='tooltiptext'>{formData.fileName3}</div></label>
                                    <label htmlFor="file-upload-3" className="custom-file-upload">Upload</label>
                                    <input id="file-upload-3" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} /> */}
                                    {false?
                                        <div className='tooltip' style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px',color:fileTypeColor(formData.scanDoc)}}>
                                            <span style={{position:'absolute',right:'0',top:'0',fontSize:'18px',cursor:'pointer'}} className="material-symbols-outlined">close</span>
                                            <span style={{position:'absolute',left:'20%',top:'20%',fontSize:'34px'}} className="material-symbols-outlined">description</span>
                                            <div className='tooltiptext'>{formData.fileName3.split("_")[1]}</div>
                                        </div>
                                    :
                                        <div style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px'}}>
                                            <label style={{cursor:'pointer',position:'absolute',right:'25%',top:'20%',fontSize:'18px'}} htmlFor="file-upload-6"><span className="material-symbols-outlined">upload</span></label>
                                            <input disabled id="file-upload-6" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} />
                                        </div>
                                    }
                                    {/* <span>Uploading...</span> */}
                                    <progress style={{width:'80%'}} value={uploadProgress6} />
                                </div>
                            </div>
                                
                        </div>

                        <div className='formRow' style={{marginBottom:'5px'}}>
                            <div className='formCol tooltip'>
                                <input {...permissions.get('stampNo')} style={{width:'95%'}} name='stampNo' type="text" placeholder="Stamp No" value={formData.stampNo} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Stamp Number</div>
                            </div>
                            {/* <input name='stampBuyCost' className='formCol' type="number" placeholder="Stamp Buy Cost" value={formData.stampBuyCost} onChange={onChangeHandler} /> */}
                            {/* <div className='formCol tooltip'>
                                <input style={{width:'95%'}} name='scanDoc' type="text" placeholder="Scan Doc" value={formData.scanDoc} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Scan Doc</div>
                            </div> */}
                            
                            <div className='formCol tooltip'>
                                <input {...permissions.get('scanQty')} style={{width:'95%'}} name='scanQty' type="number" placeholder="Scan Qty" value={formData.scanQty} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Scan Qty</div>
                            </div>
                            <div className='formCol tooltip'>
                                <input {...permissions.get('printQty')} style={{width:'95%'}} name='printQty' type="number" placeholder="Print Qty" value={formData.printQty} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Pring Qty</div>
                            </div>
                        </div>
                    </div>
                    <div style={{border:'1px grey solid'}}>
                        <div className='separater-line'>Shipping Details</div>
                        {/* <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 5px', fontWeight: '200' }}><span style={{ width: '100%', textAlign: 'center' }}><b>Shipping Details</b></span> <span style={{ color: 'white' }}>{formData.orderNo}</span></div> */}
                        <div style={{display:'flex',justifyContent:'space-evenly'}}>
                            <div style={{ width:'15%',display: 'flex', ...permissions.get('shipLabel'), alignItems: 'center', justifyContent: 'space-evenly', padding: '0 8px' }}>
                                <div  className='file-upload-col'>
                                    {/* <label className='tooltip'>{formData.fileName1.length>5?"..."+formData.fileName1.slice(-20):formData.fileName1}<div className='tooltiptext'>{formData.fileName1}</div></label> */}
                                    {/* <label htmlFor="file-upload-1" className="custom-file-upload">Upload</label> */}
                                    {formData.shipLable?
                                        <div className='tooltip' style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px',color:fileTypeColor(formData.shipLable)}}>
                                            <span onClick={() => {setFormData(() => ({...formData, shipLable:""})); setUploadProgress7(0);} } style={{position:'absolute',right:'0',top:'0',fontSize:'18px',cursor:'pointer'}} className="material-symbols-outlined">close</span>
                                            <span style={{position:'absolute',left:'20%',top:'20%',fontSize:'34px'}} className="material-symbols-outlined">description</span>
                                            <div className='tooltiptext'>{formData.shipLable}</div>
                                        </div>
                                    :
                                        <div style={{width:'50px', height:'50px',backgroundColor:'lightgrey',position:'relative',borderRadius:'5px'}}>
                                            <label style={{cursor:'pointer',position:'absolute',right:'25%',top:'20%',fontSize:'18px'}} htmlFor="file-upload-7"><span className="material-symbols-outlined">upload</span></label>
                                            <input id="file-upload-7" style={{ padding: "5px", display: 'none' }} type="file" placeholder="Documents" onChange={FileUploadHandler} />
                                        </div>
                                    }
                                    {/* <span>Uploading...</span> */}
                                    <progress style={{width:'455%'}} value={uploadProgress7} />
                                </div>
                            </div> 

                            <div style={{width:'85%'}}>
                                <div className='formRow'>
                                <div className='tooltip formCol'>
                                        <input {...permissions.get('tracking')} style={{width: '95%'}} name='tracking'  type="text" placeholder="Tracking #" value={formData.tracking} onChange={onChangeHandler} />
                                        <div className='tooltiptext'>Tracking ID</div>
                                    </div>
                                    <div className='formCol tooltip' style={{ textAlign: 'center'}}>
                                        {/* <label style={{display:'block'}} >Shipping</label> */}
                                        <select {...permissions.get('ship')} value={formData.ship.toString()} style={formError.ship ? { border: '1px solid red', width: '95%' } : { border: '0', width: '95%' }} name='ship' onChange={onChangeHandler} >
                                            <option value=""></option>
                                            <option value="1">Normal</option>
                                            <option value="2">Express</option>
                                        </select>
                                        <div className='tooltiptext'>Shipping Type</div>
                                    </div>
                                    {/* <div className='tooltip formCol'>
                                        <input style={{width: '95%'}} name='shipLable'  type="text" placeholder="Shiplabel" value={formData.shipLable} onChange={onChangeHandler} />
                                        <div className='tooltiptext'>Shipping Label</div>
                                    </div> */}
                                    
                                </div>
                                {formData.ship==1 &&
                                    <div className='formRow'>
                                        <div className='tooltip' style={{width:'100%'}}>
                                            <input {...permissions.get('shipName')} style={formError.shipName ? { border: '1px solid red', width: "95%" } : { border: '0', width: "95%" }&&{width:'95%'}} name='shipName' className='formCol' type="text" placeholder="Receiver Name" value={formData.shipName} onChange={onChangeHandler} />
                                            <div className='tooltiptext'>Receiver Name</div>
                                        </div>
                                        <div className='tooltip' style={{width:'100%'}}>
                                            <input {...permissions.get('shipPhone')} style={formError.shipPhone ? { border: '1px solid red', width: "95%" } : { border: '0', width: "95%" }&&{width:'95%'}} name='shipPhone' className='formCol' type="text" placeholder="Receiver Phone" value={formData.shipPhone} onChange={onChangeHandler} />
                                            <div className='tooltiptext'>Receiver Phone</div>
                                        </div>
                                        <div className='tooltip' style={{width:'100%'}}>
                                            <input {...permissions.get('shipAdd')} style={formError.shipAdd ? { border: '1px solid red', width: "95%" } : { border: '0', width: "95%" }&&{width:'95%'}} name='shipAdd' className='formCol' type="text" placeholder="Ship In Address" value={formData.shipAdd} onChange={onChangeHandler} />
                                            <div className='tooltiptext'>Shipping Address</div>
                                        </div>
                                    </div>
                                }
                                {formData.ship==2 &&
                                    <div className='formRow'>
                                        <div className='tooltip' style={{width:'100%'}}>
                                            <input {...permissions.get('shipName')} style={formError.shipName ? { border: '1px solid red', width: "95%" } : { border: '0', width: "95%" }&&{width:'95%'}} name='shipName' className='formCol' type="text" placeholder="Provider Name" value={formData.shipName} onChange={onChangeHandler} />
                                            <div className='tooltiptext'>Provider Name</div>
                                        </div>
                                        <div className='tooltip' style={{width:'100%'}}>
                                            <input {...permissions.get('shipPhone')} style={formError.shipPhone ? { border: '1px solid red', width: "95%" } : { border: '0', width: "95%" }&&{width:'95%'}} name='shipPhone' className='formCol' type="text" placeholder="Pickup Pin Number" value={formData.shipPhone} onChange={onChangeHandler} />
                                            <div className='tooltiptext'>Pickup Pin</div>
                                        </div>
                                        <div className='tooltip' style={{width:'100%'}}>
                                            <input {...permissions.get('shipAdd')} style={formError.shipAdd ? { border: '1px solid red', width: "95%" } : { border: '0', width: "95%" }&&{width:'95%'}} name='shipAdd' className='formCol' type="text" placeholder="Order Number" value={formData.shipAdd} onChange={onChangeHandler} />
                                            <div className='tooltiptext'>Order Number</div>
                                        </div>
                                    </div>
                                }

                                    
                                
                                {/* <div className='separater-line'></div> */}
                                

                                <div style={{ padding: '8px 8px', ...permissions.get('orderSummary')}}>
                                    <div style={{fontWeight:'600',fontSize:'12px'}} ref={orderDetails}>
                                        <span><u>Order Summary</u> - </span>
                                        {formData.orderNo && formData.orderNo + ' | '}
                                        {formData.stampVal && formData.stampVal + ' x '}
                                        {formData.stampQty && formData.stampQty + ' | '}

                                        {formData.inCusNameBtn && formData.inCusName && 'In Customer Name ( ' + formData.inCusName + ') '}
                                        {formData.inCusNameBtn && formData.inCusAddress && 'Address ( ' + formData.inCusAddress + ' ) | '}

                                        {formData.notary && 'Notary | '}
                                        <span style={{color:'red'}}>{formData.bd && new Date(formData.bd).toLocaleString('en-IN', {day:'2-digit', month:'short', year:'numeric' })+' | '}</span>
                                        <span style={{color:'red'}}>{formData.certificate? 'With Certificate | ':""}</span>
                                        {formData.scan && 'Scan | '}
                                        {formData.ship==1 && 'Normal Shipping | '}{formData.ship==2 && 'Express Shipping | '}
                                        {formData.copies && 'Copies - ' + formData.copies + ' | '}
                                        {<a style={{ color: copyTextColor, cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(orderDetails.current?.innerText || "No Data"); changeCopyTextColor() }} >Copy</a>}
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>    

                    <div style={{border:'1px grey solid'}}>     
                        <div className='separater-line'>Court Vendor</div>

                        {/* <div>
                            <input type="text" placeholder="Status" value={statusHandler} onChange={({ target }) => setStatus(target.value)} />

                        </div> */}
                        
                        {/* <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 5px', fontWeight: '200' }}><span style={{ width: '100%', textAlign: 'center' }}><b>Vendor Allocation</b></span> <span style={{ color: 'white' }}>{formData.orderNo}</span></div> */}
                        
                        <div className='formRow'>
                            <div className='formCol tooltip'>
                                <select {...permissions.get('state')} style={{width:'95%'}} value={formData.state} name='state' onChange={onChangeHandler}>
                                    <option value="">State</option>
                                    <option value="WestBengal">WestBengal</option>
                                </select>
                                <div className='tooltiptext'>State</div>
                            </div>

                            {/* <input type="checkbox" placeholder="State" value={formData.state} onChange={({ target }) => setFormData({state:target.value})} /> */}
                            <div className='formCol tooltip'>
                                <select {...permissions.get('vendor')} value={formData.vendor} name='vendor' style={{width:'95%'}} onChange={onChangeHandler}>
                                    <option value="">Vendor</option>
                                    <option value="Alipur">Alipur</option>
                                    <option value="BankShall">BankShall</option>
                                    <option value="Sealdah">Sealdah</option>
                                </select>
                                <div className='tooltiptext'>Location</div>
                            </div>
                            {/* <input type="checkbox" placeholder="Vendor" value={formData.vendor} onChange={({ target }) => setFormData({vendor:target.value})} /> */}
                            {/* <input name='shipLable' className='formCol' type="text" placeholder="Shiplabel" value={formData.shipLable} onChange={onChangeHandler} />
                            <input name='tracking' className='formCol' type="text" placeholder="Tracking #" value={formData.tracking} onChange={onChangeHandler} /> */}
                            
                            <div className='formCol tooltip'>
                                <select {...permissions.get('status')} value={formData.status} style={formError.status ? { border: '1px solid red',width:'95%' } : { border: '0',width:'95%' }} name='status'  onChange={onChangeHandler}>
                                    <option value=''>Status</option>
                                    <option value="Created">Created</option>
                                    <option value="Office">Office</option>
                                    <option value="Vendor">Vendor</option>
                                    <option value="Submitted">Submitted</option>
                                    <option value="Pickup">Pickup</option>
                                    <option value="Closed">Closed</option>
                                    <option value="Transit">Transit</option>
                                    <option value="Completed">Completed</option>
                                </select>
                                <div className='tooltiptext'>Status</div>
                            </div>    
                        </div>
                        <div className='formRow'>
                        <div className='formCol tooltip'>
                                <input {...permissions.get('orderNote')} name='orderNote' style={{width:'95%'}} type="text" placeholder="Order Notes" value={formData.orderNote} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Order Notes</div>
                            </div>
                            <div className='formCol tooltip'>
                                <input {...permissions.get('vendorNote')} name='vendorNote' style={{width:'95%'}} type="text" placeholder="Vendor Note" value={formData.vendorNote} onChange={onChangeHandler} />
                                <div className='tooltiptext'>Vendor Notes</div>
                            </div>
                        </div>
                    </div>  
                    
                    <div className='action-buttons'>
                        <button onClick={() => {permissions.reOpenCase()}} style={{display:'none',...permissions.get('reOpenBtn'),backgroundColor:'#FD1C03'}} type="button">Re Open</button>
                        <button style={{...permissions.get('submit')}} type="submit" >Save</button>
                        <button type="button" onClick={(e) => { props.showHideModal(false);props.resetTableOneEvent({}); props.tableOneRefresh() }}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default TableOneEditModal


